/**
 * Convenience fee for terminal card-present payments (credit).
 * Platform % of the base amount, capped at the base amount.
 */
export function computeTerminalConvenienceFee(
  amountDollars: number,
  platformFeePercentage = 0
): number {
  if (!Number.isFinite(amountDollars) || amountDollars <= 0) {
    return 0;
  }

  const baseAmountCents = Math.round(amountDollars * 100);
  let platformFeeCents = 0;
  if (platformFeePercentage > 0) {
    platformFeeCents = Math.round(baseAmountCents * (platformFeePercentage / 100));
  }

  const convenienceFeeCents = platformFeeCents;

  return Math.min(convenienceFeeCents / 100, amountDollars);
}
